import { render, staticRenderFns } from "./healthBlog.vue?vue&type=template&id=57422f94"
import script from "./healthBlog.vue?vue&type=script&lang=js"
export * from "./healthBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports